'use client';

import { useCallback } from 'react';
import { useRouter } from 'next/navigation';
import { useEvent } from 'effector-react';
import { useCreateNote } from '@nx-frontend/shared/hooks/use-create/use-note-create';
import { addWebEditorOnInitQueueEvent } from '@nx-frontend/shared/store/web-editor-store';

export const useCreateNewTask = () => {
  const router = useRouter();
  const createNote = useCreateNote();
  const [addWebEditorOnInitQueue] = useEvent([addWebEditorOnInitQueueEvent]);
  /**
   * Create note with task list and redirects to the created note
   * @param workspaceId
   * @param folderId
   * @returns
   */
  return useCallback(
    async ({ workspaceId, folderId }: { workspaceId: string; folderId?: string }) => {
      const note = await createNote({
        workspaceId,
        parentId: !folderId || folderId === 'root' || folderId === 'default' ? 'default' : folderId,
        redirectAfterCreate: false,
      });
      if (note) {
        addWebEditorOnInitQueue &&
          addWebEditorOnInitQueue((editor) => {
            editor.scroll.children.head.remove();
            editor.scroll.addBlot('tasks-list');
          });
        router.push('/space/' + workspaceId + '/page/' + note.globalId);
      }
    },
    [addWebEditorOnInitQueue, createNote, router]
  );
};
